// material-ui
import {Box} from '@mui/material';

const Dot = ({color, size, variant, sx}) => {
    return (
        <Box
            component="span"
            sx={{
                width: size || 8,
                height: size || 8,
                borderRadius: '50%',
                ...sx
            }}
        />
    );
};


export default Dot;
